import { useEffect } from 'react'
import { useBillingPaymentsHeaderSlot } from '@/features/BillingPayments/components/BillingPaymentsHeaderSlot/useBillingPaymentsHeaderSlot'
import { PayablesSummaryTableContainer } from '@/features/BillingPayments/containers/PayablesSummaryTableContainer/PayablesSummaryTableContainer'
import { PayablesSummaryActions } from './PayablesSummaryActions'
import { useBillingFiltersGetParams } from '@/features/BillingPayments/hooks/useBillingFiltersGetParams'
import { useBillingFiltersStore } from '../../stores/useBillingFiltersStore/useBillingFiltersStore'

export const PayablesSummary = () => {
    const { setSlot } = useBillingPaymentsHeaderSlot()

    const activeBillingFilters = useBillingFiltersStore(
        (state) => state.activeFilters
    )
    const filters = useBillingFiltersGetParams(activeBillingFilters)

    useEffect(() => {
        setSlot(<PayablesSummaryActions filters={filters} />)
        return () => {
            setSlot(null)
        }
    }, [setSlot, filters])

    return (
        <div className="h-full overflow-hidden p-6">
            <PayablesSummaryTableContainer filters={filters} />
        </div>
    )
}
